
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 17.38H.362A.362.362 0 010 17.018V3.983c0-.2.162-.362.362-.362H7V17.38z","fill":"#73AF00"}}),_c('path',{attrs:{"d":"M14 3.621H7V17.38h7V3.62z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M20.638 17.38H14V3.62h6.638c.2 0 .362.162.362.362v13.035c0 .2-.162.362-.362.362z","fill":"#FF9B46"}})])
          )
        }
      }
    